module.exports = __webpack_public_path__ + "img/news_list_7.80bed0cf.jpg";